import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    width: 500px;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    @media screen and (max-width: 873px){
        flex-direction: column-reverse;
        height: 345px;
        min-width: 360px;
        width: 360px;
     };
`;

const WrapText = styled.section`
    display: flex;
    flex-direction: column;
    font-size: 13px;
    height: 130px;
    width: 350px;
    margin: 25px;
    justify-content: space-between;

    @media screen and (max-width: 873px){
        margin-left: 38px;
        margin-bottom: 31px;
        width: 219px;
     };
`

const ImageCard = styled.img`
    width: 30%;
    height: 30%;
    margin-top: 20px;
    margin-bottom: 20px;
    object-fit: cover;

    @media screen and (max-width: 873px){
        width: 285px;
        max-height: 115px;
        margin-left: 38px;
     };
`;


const CardTentangPerusahaan = ({
    namaBrand,
    namaResmi,
    lokasi,
    negara,
    sektorBisnis,
    ukuranPerusahaan,
    logo}) => {
   
    return (
           <Container>
                <ImageCard src={logo}/>
                <WrapText>
                    <span style={{fontSize: '24px', fontWeight: '600'}}>{namaBrand}</span>
                    <span style={{fontWeight: '600'}}>{namaResmi} | {lokasi}, {negara}</span>
                    <span style={{color: '#828282'}}><i className='bx bx-time-five'></i> {sektorBisnis}</span>
                    <span style={{color: '#828282'}}><i className='bx bx-badge-check'></i> {ukuranPerusahaan}</span>
                </WrapText>
           
       </Container>
    )
}

export default CardTentangPerusahaan
